import type { VFC } from 'react'
import type { Row } from 'react-table'
import type { TrustedIpTableRow } from '../TrustedIpTable'
import {
  Input
} from '@panwds/react-form'
import {
  Body
} from '@panwds/react-ui'
import { useCallback, useEffect, useMemo } from 'react'
import {
  ERROR_IP_INVALID,
  FORM_LABEL_IP_ADDRESS,
  ERROR_IP_USED, ERROR_IP_NOT_V4,
  ERROR_IP_IS_PRIVATE,
  LABEL_IP_INPUT_DESC
} from '../../../constants/LabelConstants'
import { useFormContext } from 'react-hook-form'
import ipaddr from 'ipaddr.js'
import validator from 'validator'

const IpCellRenderer: VFC<{
  row: Row<TrustedIpTableRow>,
  value: string,
  updateData: Function
}> = ({ row, value: rowValue, updateData }) => {

  const { original } = row

  const { id, used_ips } = original
  const {
    setFocus,
    trigger
  } = useFormContext()

  const onKeyDown = useCallback(async (event: any) => {
    const key = event.key
    if (event.relatedTarget && ['submit', 'button'].includes(event.relatedTarget.type)) {
      return
    }
    if (['Enter'].includes(key)) {
      const isValid = await trigger(id)
      if (isValid) {
        updateData()
      }
    }
  }, [trigger, id, updateData])

  const content = useMemo(() => {
    if (rowValue === 'new') {
      return (
        <Input
          label={FORM_LABEL_IP_ADDRESS}
          placeholder={'127.0.0.1/32'}
          name={id}
          showLabel={false}
          autoFocus
          onKeyDown={onKeyDown}
          description={LABEL_IP_INPUT_DESC}
          register={{
            required: true,
            onBlur: (event) => onKeyDown({ ...event, key: 'Enter' }),
            validate: {
              isValidIp: value => (value && value.includes('/') ? validator.isIPRange(value) : validator.isIP(value)) || ERROR_IP_INVALID,
              isIpv4: value => ipaddr.parse(`${value}`.split('/')[0]).kind() === 'ipv4' || ERROR_IP_NOT_V4,
              isPublic: value => ipaddr.parse(`${value}`.split('/')[0]).range() === 'unicast' || ERROR_IP_IS_PRIVATE,
              ipAlreadyUsed: value => !used_ips.includes(value) || ERROR_IP_USED
            }
          }}
        />
      )
    }
    return (
      <Body addClassName='cm-truncate'>{rowValue}</Body>
    )
  }, [rowValue, id, onKeyDown, used_ips])

  useEffect(() => {
    setFocus(id)
  }, [content, id, rowValue, setFocus])

  return (
    <div className='cm-p-1 cm-w-full'>
      {content}
    </div>
  )
}

export default IpCellRenderer
